import { GeoFence, GeoFenceEvents, getSpeedThresholdColor } from '@/feature/observatory'

import { Asset } from '@/lib/features/Assets/interfaces'

import { AssetLocationHistory } from '../../api/useAssetLocationHistory'
import { SpeedLineGraphTrack } from '../ReplayTimeRange'
import { MarkerTrack } from '../ReplayTimeRange/ReplayTimeRange.types'

// The speed bands drawn in the legend. The colours mirror getSpeedThresholdColor, which paints the
// matching points on the track, so a change there needs the same change here.
export const SPEED_LEGEND = [
  { color: '#B8B8B8', label: '0 km/h' },
  { color: '#4D74FF', label: '1–60 km/h' },
  { color: '#1BCA00', label: '61–80 km/h' },
  { color: '#FE9009', label: '81–100 km/h' },
  { color: '#EC0F00', label: '101+ km/h' },
] as const

export const basicAssetTrackMarkers = (
  assetHistoryEvents: AssetLocationHistory | undefined,
): MarkerTrack => {
  return {
    // Draws the speed line itself from `speed`, so the points need no per-point sizing — this used
    // to fake the chart by giving each point a bottom margin proportional to its speed.
    trackComponent: SpeedLineGraphTrack,
    points:
      assetHistoryEvents?.map((event) => ({
        when: event.deviceTimestamp,
        speed: event.speed,
        pointColour: getSpeedThresholdColor(event.speed),
      })) ?? [],
    trackStyle: {
      alignItems: 'end',
      minHeight: '2.5rem',
    },
  }
}

export const basicGeoFenceTrackMarkers = (
  geofenceEventsData: GeoFenceEvents | undefined,
  geoFences: GeoFence[],
  asset: Asset,
): [MarkerTrack, MarkerTrack] => {
  return Object.entries(geofenceEventsData ?? {}).reduce(
    ([highRisk, normal], [k, e]) => {
      const geoFence = geoFences.find((f) => f.id === Number.parseInt(k, 10))
      for (const r of e.records) {
        if (r.vehicleBridgeId === asset.vehicleBridgeId) {
          const eventType = geoFence?.highRiskArea ? highRisk : normal
          eventType.points.push({
            when: new Date(r.enter.timestamp),
          })
        }
      }

      return [highRisk, normal]
    },
    [{ points: [], pointStyle: { padding: 0 } }, { points: [] }] as [MarkerTrack, MarkerTrack],
  )
}
